import React from 'react'
import { Helmet } from 'react-helmet-async'
import { AgencyAnalyticsLayout } from '../../layouts'

const AgencyAnalyticsPage = (): React.ReactElement => (
  <React.Fragment>
    <Helmet>
      <title>Manage Accounts</title>
      <meta name="description" content="Manage Accounts page" />
    </Helmet>
    <AgencyAnalyticsLayout />
  </React.Fragment>
)

export default AgencyAnalyticsPage
